@use '../../scss/utility';
@use './dot-navigation-vars';
@use './dot-element/dot-element';

:host {
  @include dot-navigation-vars.wb-dot-navigation-vars;

  position: relative;
  display: flex;
  justify-content: center;
}

.container {
  display: flex;
  height: var(--dot-navigation-height);
  padding: var(--dot-navigation-padding);
  border-radius: var(--dot-navigation-border-radius);
}

.dots {
  display: flex;
  align-items: center;
  gap: var(--dot-navigation-gap);
}

:host([prevent-interaction]) {
  pointer-events: none;
}

:host([contrast]),
:host([has-background]) {
  .container {
    background-color: var(--dot-navigation-background-color);
  }
}
